// Constantes pour sessionStorage
export const PREVIOUS_PAGE_TYPE_KEY = 'previous_page_type';
export const COMMANDE_FILTER_PARAMS_KEY = 'backoffice_commande_filter_params';
export const DEVIS_FILTER_PARAMS_KEY = 'backoffice_devis_filter_params';
export const BACKOFFICE_FILTER_PARAMS_KEY = 'backoffice_filter_params';
export const PANIER_RETURN_URL_KEY = 'backoffice_panier_return_url';
// Marqueur de validation d'un panier PDF : déposé par la page panier avant la
// redirection vers la liste des imports PDF, qui le supprime et affiche le toast.
export const PANIER_PDF_VALIDE_KEY = 'backoffice_panier_pdf_valide';

export const PAGE_TYPE = {
  CLIENTS: 'clients', // Page de la liste des clients dans Activation
  COMMANDE: 'commande', // Page de la liste des clients dans la prise de commande
  DEVIS: 'devis', // Page de la liste des clients pour devis personnalisés
  PANIER: 'panier', // Page du panier (prise de commande)
};
